import * as React from "react";
type Props = {
  fill: string;
  width?: number;
  height?: number;
};
function CardioIconSvg(props: Props) {
  const { fill, width = 16, height = 16 } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_1189_2590)">
        <path
          d="M12.989 4.99753C14.0875 4.99753 14.978 4.10703 14.978 3.00853C14.978 1.91004 14.0875 1.01953 12.989 1.01953C11.8905 1.01953 11 1.91004 11 3.00853C11 4.10703 11.8905 4.99753 12.989 4.99753Z"
          fill={fill}
        />
        <path
          d="M7.30097 9.73438L5.54297 10.7884L7.05197 15.3144C7.13578 15.5663 7.31624 15.7747 7.55366 15.8936C7.79108 16.0125 8.06601 16.0322 8.31797 15.9484C8.56992 15.8646 8.77827 15.6841 8.89717 15.4467C9.01606 15.2093 9.03578 14.9343 8.95197 14.6824L7.30097 9.73438Z"
          fill={fill}
        />
        <path
          d="M13.8662 10.523L10.7852 4.73001C10.6238 4.46297 10.3829 4.25315 10.0962 4.13001L4.49919 1.08701C4.38389 1.0241 4.25733 0.984526 4.12673 0.970535C3.99613 0.956543 3.86406 0.968412 3.73805 1.00546C3.48357 1.08029 3.26923 1.25315 3.14219 1.48601C3.01515 1.71887 2.98582 1.99266 3.06064 2.24714C3.13547 2.50163 3.30833 2.71597 3.54119 2.84301L7.45519 4.97801L3.72719 7.21501C3.55782 7.31611 3.41022 7.44985 3.29297 7.60847C3.17572 7.76709 3.09116 7.94743 3.04419 8.13901L1.04419 14.707C0.966214 14.9606 0.992155 15.2347 1.1163 15.4691C1.24045 15.7035 1.45264 15.879 1.70619 15.957C1.95973 16.035 2.23387 16.009 2.46829 15.8849C2.70271 15.7607 2.87821 15.5486 2.95619 15.295L4.51019 10.245L7.74919 8.30101L9.77019 7.08801L12.1092 11.479C12.236 11.712 12.4501 11.8851 12.7045 11.9602C12.9589 12.0353 13.2327 12.0063 13.4657 11.8795C13.6987 11.7527 13.8718 11.5386 13.9469 11.2842C14.022 11.0298 13.993 10.756 13.8662 10.523V10.523Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}

export default CardioIconSvg;
